import { GcfPriceDisplayFormat } from 'src/features/components/editComponentPage/forms/FormSelector.interface';
import {
  GcfPriceLabelShapeTypeEnum,
  GcfPriceLabelTypeEnum,
  TextAlignmentEnum,
} from 'src/interfaces';

export const BASE_GCF_COMPONENT_CONFIG = {
  background: '',
  productList: {},
  priceLabel: {
    type: GcfPriceLabelTypeEnum.Size,
    shape: GcfPriceLabelShapeTypeEnum.None,
  },
  subProductsDisplayFormat: {
    type: GcfPriceDisplayFormat.INLINE,
  },
};

export const COMMON_GCF_COMPONENT_CONFIG = {
  ...BASE_GCF_COMPONENT_CONFIG,
  header: {
    text: '',
    alignment: TextAlignmentEnum.LEFT,
    visible: false,
    description: {
      text: '',
      alignment: TextAlignmentEnum.LEFT,
      visible: false,
    },
  },
  disclaimer: {
    text: '',
  },
};
